<!--
 * @Autor: zouning@szkingdom.com
 * @Date: 2026-01-14 13:10:43
 * @Description: 
 * @LastEditors: zouning@szkingdom.com
-->
<!--
Author: TangChen
Date: 2018-09-05
Desc: 注册页面组件，由router.js 配置引入
-->
<template>
    <div class="view-outframe view">
        <header-com-dc :tit="titText">
            <template v-if="$route.name === 'register'">
                <li>已有账号？</li>
                <li>
                    <el-button
                        type="primary"
                        class="login-btn"
                        v-on:click.prevent="$router.push({ name: 'login' })"
                    >
                        <div>
                            <img
                                class="act-img"
                                :src="require('../../assets/img/user.png')"
                                alt=""
                            />
                            <span>立即登录</span>
                        </div>
                    </el-button>
                </li>
            </template>
        </header-com-dc>
        <div class="container" style="min-height: 68vh">
            <router-view />
        </div>
        <log />
        <!-- <footer-com style="visibility: hidden;" /> -->
        <!-- <footer-com style="bottom:0px;position:absolute;width:100%;" /> -->
        <zx-footer />
    </div>
</template>

<script>
import headerComDc from "@/components/layout/headerDc.vue";
import footerCom from "@/components/layout/footer.vue";
import zxFooter from "@/components/layout/zxFooter.vue";
import log from "@/components/misc/log.vue";

export default {
    components: {
        headerComDc,
        // footerCom,
        log,
        zxFooter
    },
    data() {
        return {
            titText: ""
        };
    },
    mounted() {
        if (this.$route.meta) {
            this.titText = this.$route.meta.tit || "";
        }
    }
};
</script>
<style lang="scss" scoped>
.login-btn {
    div {
        display: flex;
        align-items: center;
    }
    width: 120px;
    img {
        width: 14px;
        height: 14px;
        margin-right: 6px;
    }
}
</style>
